import throttle from "../utils/throttle";

const HeroComponent = (el) => {
  const poster = el.querySelector("[data-poster-url]");
  if (!poster) return;
  const aspectWidth = poster.dataset.aspect.split(":").shift() * 1;
  const aspectHeight = poster.dataset.aspect.split(":").pop() * 1;

  const onResize = () => {
    if (poster) {
      const { width, height } = poster.getBoundingClientRect();
      const percent = (width * aspectHeight) / aspectWidth / height;
      el.style.setProperty(
        "--hero-height",
        Math.round(percent * 10000) / 100 + "%",
      );
    }
  };
  window.addEventListener("resize", throttle(onResize, 200));
  onResize();
};

export default HeroComponent;
